var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H9C4.03125 3 0 7.03125 0 12C0 16.9688 4.03125 21 9 21H18C22.9688 21 27 16.9688 27 12C27 7.03125 22.9688 3 18 3ZM18 18C14.6812 18 12 15.3141 12 12C12 8.68125 14.6859 6 18 6C21.3188 6 24 8.68594 24 12C24 15.3188 21.3141 18 18 18Z",
    fill: "#FDA600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOnIcon);
export default __webpack_public_path__ + "static/media/toggleOnIcon.78077dd44b5d01de10789e306f9ae744.svg";
export { ForwardRef as ReactComponent };